import { useFormContext } from "react-hook-form";
import TextArea from "@/components/TextArea/TextArea";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type LanguageInputFields = {
  language: string;
};

const LanguageInput = ({
  languageFieldConfig,
}: {
  languageFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<LanguageInputFields>();

  return (
    <TextArea
      label={t`Språk`}
      showOptionalLabel={
        languageFieldConfig === informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.language?.message}
      {...register("language", {
        required: {
          value:
            languageFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange språk`,
        },
      })}
    />
  );
};

export default LanguageInput;
